export const createSearchQueryParams = (filters = {}) => {
    const params = new URLSearchParams();

    for (const [key, value] of Object.entries(filters)) {
        if (Array.isArray(value)) {
            const filtered = value.filter((item) => item && item !== 'All');

            if (filtered.length > 0) {
                params.set(key, filtered.join(','));
            }
        } else if (value !== '' && value != null) {
            params.set(key, value);
        }
    }

    return params.toString();
};

export const convertSearchQueryParamsToPlainObj = (searchParams) => {
    const filters = {};

    for (const [key, value] of searchParams.entries()) {
        if (key === 'maxDays' || key === 'maxNights') {
            filters[key] = value;
        } else {
            filters[key] = value.split(',');
        }
    }

    return filters;
};
